<template>
  <section class="closing">
    <div class="closing__surface">
      <div class="closing__consistency">
        <div class="closing__consistency-copy">
          <DsText as="subtitle4" class="closing__consistency-title">Mant&eacute;n la constancia</DsText>
          <DsText as="body4" class="closing__consistency-intro">
            La constancia mantiene tus beneficios activos
          </DsText>
        </div>

        <img :src="consistencyIllustration" alt="" class="closing__consistency-illustration" aria-hidden="true">

        <div class="closing__points">
          <article v-for="point in points" :key="point.title" class="closing__point">
            <div class="closing__point-head">
              <img :src="consistencyPointIcon" alt="" class="closing__point-icon" aria-hidden="true">
              <DsText as="subtitle7" class="closing__point-title">{{ point.title }}</DsText>
            </div>

            <DsText as="body4" class="closing__point-copy">{{ point.copy }}</DsText>
          </article>
        </div>
      </div>

      <DsPaymentGuideDownload />

      <DsContactHelp />
    </div>
  </section>
</template>

<script setup lang="ts">
import DsText from '../atoms/DsText.vue'
import DsContactHelp from '../components/DsContactHelp.vue'
import DsPaymentGuideDownload from '../components/DsPaymentGuideDownload.vue'
import consistencyIllustration from '../../../assets/pagos_closing_consistency.svg'
import consistencyPointIcon from '../../../assets/pagos_closing_point_icon.svg'

const points = [
  {
    title: 'Los pagos tard\u00edos generan impuntualidad',
    copy: 'Cada pago fuera de fecha queda registrado en tu historial y puede afectar tu calificaci\u00f3n crediticia.'
  },
  {
    title: 'Tus beneficios se reinician',
    copy: 'Si faltas un mes, los descuentos acumulados por puntualidad regresan a cero y deber\u00e1s comenzar de nuevo.'
  }
]
</script>

<style scoped>
.closing__surface {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.closing__consistency {
  background: var(--ds-grey-50);
  border-radius: 32px;
  padding: 40px 24px;
  box-sizing: border-box;
  gap: 1rem;
}

.closing__consistency-copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 6px;
}

.closing__consistency-title {
  color: var(--ds-purple-900);
  font-size: var(--ds-h4-size);
  font-weight: 700;
  font-family: var(--ds-font-family-bebas);
  line-height: 1;
}

.closing__consistency-intro {
  color: var(--ds-text-primary);
  font-size: var(--ds-body3-size);
  font-weight: 400;
  font-family: var(--ds-font-family-inter);
  max-width: 20ch;
}

.closing__consistency-illustration {
  width: 100%;
  max-width: 115px;
  height: auto;
  display: block;
  margin: 16px 0 0 6px;
}

.closing__points {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 12px 6px 0;
}

.closing__point {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.closing__point-head {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.closing__point-icon {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
  margin-top: -2px;
  flex: 0 0 auto;
}

.closing__point-title {
  color: var(--ds-purple-900);
  font-size: var(--ds-body4-size);
  font-weight: 600;
  font-family: var(--ds-font-family-inter);
  line-height: 1.15;
  max-width: 20ch;
}

.closing__point-copy {
  color: var(--ds-text-primary);
  font-size: var(--ds-subtitle15-size);
  font-weight: 400;
  font-family: var(--ds-font-family-inter);
  line-height: 1.2;
  max-width: 38ch;
}

@media (min-width: 768px) {
  .closing__consistency {
   padding: 40px 24px;
  }

  .closing__surface {
    gap: 14px;
  }

  .closing__consistency-copy {
    gap: 6px;
    padding: 0;
  }

  .closing__consistency-intro {
    max-width: none;
  }

  .closing__consistency-illustration {
    max-width: 88px;
    margin: 14px 0 0;
  }

  .closing__points {
    gap: 14px;
    padding: 10px 0 0;
  }

  .closing__point {
    gap: 5px;
  }

  .closing__point-icon {
    width: 18px;
    height: 18px;
    margin-top: -1px;
  }

  .closing__point-title {
    max-width: none;
  }

  .closing__point-copy {
    max-width: none;
    line-height: 1.2;
  }
}

@media (min-width: 1208px) {
  .closing {
    max-width: 962px;
    width: 100%;
    margin: 0 auto;
  }

  .closing__surface {
    gap: 18px;
  }

  .closing__consistency {
    border-radius: 24px;
    padding: 40px 24px;
  }

  .closing__consistency-copy {
    gap: 4px;
  }

  .closing__consistency-illustration {
    max-width: 90px;
    margin: 12px 0 0;
  }

  .closing__points {
    gap: 12px;
    padding-top: 10px;
  }

  .closing__point {
    gap: 4px;
  }

  .closing__point-head {
    gap: 5px;
  }

  .closing__point-icon {
    width: 16px;
    height: 16px;
    margin-top: 0;
  }

  .closing__point-title {
    line-height: 1.15;
  }

  .closing__point-copy {
    line-height: 1.2;
  }
}
</style>

